import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import DisclaimerNote from './utils/DisclaimerNote';
import ChangePaymentDisclaimer from './utils/Disclaimer';
import { DisclaimerContainer } from './utils/subcomponents';
const Disclaimer = () => {
    return (_jsx(DisclaimerContainer, { children: _jsxs(Inset, { vertical: "xlarge", horizontal: "large", hideOnBreakpointDown: "small", children: [_jsx(DisclaimerNote, {}), _jsx(Stack, { size: "base" }), _jsx(ChangePaymentDisclaimer, {})] }) }));
};
export default Disclaimer;
